<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Master Data</li>
                <li class="breadcrumb-item">User</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card mt-5">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">Detail User</h4>
          <b-button v-b-modal.modal-1 variant="primary" @click="btnBack">
            Close
          </b-button>
        </div>
        <div class="card-body">
          <div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>Name</label>
                  <input name="name" type="text" required class="form-control" v-model="payload.fullname" disabled />
                </div>
                <div class="form-group">
                  <label>Email</label>
                  <input name="email" type="email" class="form-control" v-model="payload.email" disabled />
                </div>
                <div class="form-group">
                  <label>Phone</label>
                  <input name="contact" type="text" class="form-control" v-model="payload.contact" disabled />
                </div>
                <div class="form-group">
                  <label>Role</label>
                  <v-select
                      :options="listRole"
                      v-model="payload.role_id"
                      :reduce="(e) => e.value"
                      placeholder="Select/Type Here..."
                      class="w-md-auto"
                      disabled="disabled"
                  />
                </div>
                <div class="form-group">
                  <label>Department</label>
                  <v-select
                      :options="listDivisi"
                      v-model="payload.department_id"
                      :reduce="(e) => e.value"
                      placeholder="Select/Type Here..."
                      class="w-md-auto"
                      multiple
                      disabled="disabled"
                  />
                </div>


              </div>
              <div class="col-12 m-2">
                <b-card class="p-0 m-0">
                  <b-card-header class="p-0 m-0">
                    <div><b>Budget Plan</b></div>
                  </b-card-header>
                  <b-card-body class="p-0 m-0">
                    <table class="table table-bordered">
                      <thead>
                      <tr>
                        <td class="text-center" width="20">No.</td>
                        <td width="100">Title</td>
                        <!--                        <td width="100">Total</td>-->
                        <td width="100">Year</td>
                        <td width="100">Department</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="listBudgetPlan" v-for="(item, index) in listBudgetPlan" :key="index">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ item.title }}</td>
                        <!--                        <td>{{ item.total }}</td>-->
                        <td>{{ item.year }}</td>
                        <td>{{ item?.fund_center?.department_name }}</td>
                      </tr>
                      </tbody>
                    </table>
                    <!--                        <vue-good-table :line-numbers="true" :columns="columns" :rows="listBudgetPlan" style-class="vgt-table border-0 table font-datatable" @on-page-change="onPageChange"
                                                           >
                                              &lt;!&ndash; Loading &ndash;&gt;
                                              <div slot="emptystate" class="text-center font-size-14">
                                                No data available
                                              </div>
                                            </vue-good-table>-->
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import index from "vuex";
import axiosIns from "@/api/axios";

export default {
  name: "ListUser",
  components: {ToggleSwitch},
  computed: {
    detail() {
      this.$store.getters["user/detail"];
      this.payload.fullname = detail.fullname;
      this.payload.email = detail.email;
      this.payload.contact = detail.contact;
      this.payload.role_id = detail.role_id;
      this.payload.department_id = detail.department_id;
      console.log("detail data: ", this.payload)
    },
  },
  data() {
    return {
      listBudgetPlan: [],
      payload: {
        fullname: "",
        email: "",
        role_id: "",
        contact: "",
        department_id: [],
      },
      divisi_id: "",
      department_id: [],
      role_id: "",
      id: "",
      isAdd: true,
      isLoading: false,
      listRole: [],
      listDivisi: [],
      listMember:[],
      listDepartement: [],
      listDepartement_:[],
      is_divisi: false,
      selectedRole: null,
      paramName: null,
      paramEmail: null,
      paramRole: null,

    };
  },

  mounted() {
    this.getDetail();
    this.getListRole();
    this.getListDivisi();
    this.role_id = localStorage.getItem('roles')
  },
  methods: {
    async getListRole() {
      try {
        const response = await axiosIns.get("/master-role");
        this.listRole = response.data.data.data.map(items => ({
          label: items.roles_name,
          value: items.id
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },
    async getListDivisi() {
      try {
        const response = await axiosIns.get("/master-org-chart/divisi");
        this.listDivisi = response.data.data.map(items => ({
          label: items.name,
          value: items.id
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },
    async getListDepartement(id) {
      try {
        this.listDepartement = [];
        //console.log("id: ", id);
        const response = await axiosIns.get("/master-org-chart/"+ id);
        if(response?.data?.data[0].parent) {
          this.divisi_id = response?.data?.data[0].parent.id;
          this.department_id = id;
        }else{
          this.divisi_id = id;
          this.department_id = "";
        }
        console.log("childs: ", response?.data?.data[0].childs);
        console.log("members: ", response?.data?.data[0].members);

        console.log("divisi_id: ", this.divisi_id);
        console.log("department_id: ", this.department_id);
        if(response?.data?.data[0]?.childs.length > 0) {
          this.listDepartement_ = response?.data?.data[0]?.childs.map(items => ({
            label: items.name,
            value: items.id
          }));
        }
        if(response?.data?.data[0]?.members.length > 0) {
          this.listMember = response?.data?.data[0]?.members.map(items => ({
            label: items.fullname,
            value: items.id
          }));
        }

      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },
    handleChangeDivisi() {
      this.listDepartement = [];
      if(this.payload.department_id){
        this.getListDepartement(this.payload.department_id);
      }
    },
    btnBack() {
      this.$router.push(`/master-data/user`)
    },
    saveAdd() {
      try {
        const id = this.$router.currentRoute.query.id;
        this.isLoading = true;
        /*this.payload.department = this.department_id.label;
        this.payload.department_id = parseInt(this.department_id.value);

        this.payload.divisi = this.divisi_id.label;
        this.payload.divisi_id = parseInt(this.divisi_id.value);*/
        let param = {
          id: id,
          body: this.payload
        }
        this.$store
            .dispatch("user/UPDATE_DATA", param)
            .then((resp) => {
              this.$swal("Saved", "Your input has been saved", "success").then(
                  (resp) => {
                    this.isLoading = false;
                    this.$bvModal.hide("modal-1");
                    this.$router.push(`/master-data/user`)
                  }
              );
            });
      } catch (error) {
        this.$swal("Error", "Error while add data", "error");
      }
    },
    async getDetail() {
      const id = this.$router.currentRoute.query.id;
      try {
        const response = await axiosIns.get("/master-user/"+ id).then(response => {
          this.payload.fullname = response.data.data[0].fullname;
          this.payload.email = response.data.data[0].email;
          this.payload.contact = response.data.data[0].contact;
          if(response.data.data[0]?.role_mapping.role.id){
            this.payload.role_id = response.data.data[0]?.role_mapping.role.id;
          }
          if(response.data.data[0].department_id){
            this.getListDepartementPrev(response.data.data[0].department_id);
          }
          if(response.data.data[0].organization){
            const org = response.data.data[0].organization;
            for (let i = 0; i < org.length; i++) {
              this.payload.department_id.push(org[i].id)
            }
          }

        })
            .catch(error => {
              // handle error
              console.error('Error:', error)
            });

        if(this.payload.department_id){
          const org_chart_payload = {
            code: this.payload.department_id
          }
          const responseOrgChart = await axiosIns.post("/fund-center/by-list-code", org_chart_payload);
          this.listBudgetPlan = responseOrgChart.data.data;
          //console.log("responseOrgChart: ", responseOrgChart.data.data);
        }

      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }




    },
  },
};
</script>
